const DEFAULT_LOCALE = "en";

const TRANSLATIONS = {
  en: {
    "landing.brand.tag": "Create, edit, publish — faster.",
    "landing.nav.features": "Features",
    "landing.nav.workflow": "Workflow",
    "landing.nav.faq": "FAQ",
    "landing.hero.title": "The studio to produce content at high speed.",
    "landing.hero.lead":
      "Centralize assets, generate scripts, assemble Reels/Shorts, and export ready-to-post formats.",
    "landing.badge.templates": "Templates & presets",
    "landing.badge.subtitles": "Subtitles & branding",
    "landing.badge.exports": "Reels/Shorts/TikTok exports",
    "landing.badge.editing": "Semi-automatic editing",
    "landing.workflow.title": "Workflow",
    "landing.workflow.step1": "Import videos, music, logos",
    "landing.workflow.step2": "Compose on a timeline (or auto-edit)",
    "landing.workflow.step3": "Export in 1080x1920, normalized audio",
    "landing.tabs.login": "Sign in",
    "landing.tabs.signup": "Create account",
    "landing.field.name": "Name",
    "landing.field.email": "Email",
    "landing.field.password": "Password",
    "landing.placeholder.name": "Your name",
    "landing.placeholder.email": "you@example.com",
    "landing.placeholder.password": "••••••••",
    "landing.submit.login": "Sign in",
    "landing.submit.signup": "Create my account",
    "landing.forgot.link": "Forgot password?",
    "landing.forgot.title": "Reset password",
    "landing.forgot.subtitle": "We will send you a link to reset your password.",
    "landing.forgot.email": "Email",
    "landing.forgot.submit": "Send reset link",
    "landing.forgot.sent": "Email sent. Check your inbox.",
    "terms.prefix": "By continuing, you accept our",
    "terms.and": "and our",
    "terms.cgu": "Terms of Service",
    "terms.privacy": "Privacy Policy",
    "landing.faq.title": "FAQ",
    "landing.faq.access": "What do I get after login?",
    "landing.faq.access.answer": "You are redirected to the app on /nano.",
    "landing.faq.design": "Can I change the design?",
    "landing.faq.design.answer": "Yes, it is classic React/CSS, easy to brand.",

    // Decor Landing
    "decor.brand.name": "DecorAI Studio",
    "decor.brand.tag": "Transform your spaces with AI",
    "decor.hero.title": "Redesign any room in seconds with AI",
    "decor.hero.lead": "Upload a photo, select what to change, and let our AI generate stunning interior design variations. Professional results, creative freedom.",
    "decor.stat.ai": "Gemini AI",
    "decor.stat.variations": "Variations",
    "decor.stat.versions": "Versions",
    "decor.tabs.login": "Sign in",
    "decor.tabs.signup": "Get started",
    "decor.field.name": "Name",
    "decor.field.email": "Email",
    "decor.field.password": "Password",
    "decor.placeholder.name": "Your name",
    "decor.placeholder.email": "you@example.com",
    "decor.placeholder.password": "••••••••",
    "decor.submit.login": "Sign in",
    "decor.submit.signup": "Start creating",
    "decor.forgot.link": "Forgot password?",
    "decor.forgot.title": "Reset password",
    "decor.forgot.subtitle": "We will send you a link to reset your password.",
    "decor.forgot.email": "Email",
    "decor.forgot.submit": "Send reset link",
    "decor.forgot.sent": "Email sent. Check your inbox.",
    "decor.auth.emailConfirm": "Account created! Check your email to activate.",
    "decor.features.title": "Everything you need to redesign",
    "decor.features.subtitle": "Professional tools powered by AI for interior designers and creators",
    "decor.feature.editor.title": "Smart Mask Editor",
    "decor.feature.editor.desc": "Select specific areas to modify. Compare results side-by-side with a 4-variation grid.",
    "decor.feature.libraries.title": "Asset Libraries",
    "decor.feature.libraries.desc": "Curated collections of colors, textures (wood, concrete, marble), and furniture pieces.",
    "decor.feature.ai.title": "AI Generation",
    "decor.feature.ai.desc": "Powered by Gemini 3 Pro Image. Use multiple reference images for precise results.",
    "decor.feature.projects.title": "Project Management",
    "decor.feature.projects.desc": "Automatic versioning, complete history, and HD export for all your designs.",
    "decor.pricing.title": "Simple, transparent pricing",
    "decor.pricing.subtitle": "Choose the plan that fits your creative needs",
    "decor.pricing.popular": "Popular",
    "decor.pricing.free": "Free",
    "decor.pricing.starter.title": "Starter",
    "decor.pricing.starter.credits": "10 free credits to start",
    "decor.pricing.starter.feat1": "All features included",
    "decor.pricing.starter.feat2": "Access to libraries",
    "decor.pricing.starter.feat3": "HD export",
    "decor.pricing.pack50.title": "Pack 50",
    "decor.pricing.pack50.credits": "50 generation credits",
    "decor.pricing.pack50.feat1": "Best value per credit",
    "decor.pricing.pack50.feat2": "Never expires",
    "decor.pricing.pack50.feat3": "Priority support",
    "decor.pricing.pack200.title": "Pack 200",
    "decor.pricing.pack200.credits": "200 generation credits",
    "decor.pricing.pack200.feat1": "Maximum savings",
    "decor.pricing.pack200.feat2": "Never expires",
    "decor.pricing.pack200.feat3": "Priority support",
    "decor.pricing.pro.title": "Pro",
    "decor.pricing.pro.credits": "Unlimited credits",
    "decor.pricing.pro.feat1": "Unlimited generations",
    "decor.pricing.pro.feat2": "Advanced features",
    "decor.pricing.pro.feat3": "Priority support",
    "decor.pricing.pro.feat4": "Early access to new features",
    "decor.faq.title": "Frequently Asked Questions",
    "decor.faq.q1": "How does the AI generation work?",
    "decor.faq.a1": "Upload a photo of your room, use the mask editor to select areas to modify, add reference images (colors, textures, furniture), and our AI generates 4 variations instantly.",
    "decor.faq.q2": "What are credits?",
    "decor.faq.a2": "Each AI generation costs 1 credit. You get 10 free credits to start, then purchase packs or subscribe to Pro for unlimited generations.",
    "decor.faq.q3": "Can I export in high resolution?",
    "decor.faq.a3": "Yes! All plans include HD export. Download your designs in JPEG or PNG format, perfect for presentations or client proposals.",
    "decor.faq.q4": "Do credits expire?",
    "decor.faq.a4": "No, purchased credit packs never expire. Use them at your own pace. Only the Pro subscription is monthly.",
    "decor.footer.rights": "All rights reserved",

    // Reset Password
    "reset.title": "Reset password",
    "reset.subtitle": "Choose a new password for your account.",
    "reset.password": "New password",
    "reset.password.placeholder": "Your new password",
    "reset.password.confirm": "Confirm password",
    "reset.password.confirm.placeholder": "Confirm your password",
    "reset.submit": "Update password",
    "reset.success": "Password updated. You can sign in.",
    "reset.error.missing": "Invalid link. Request a new reset.",
    "reset.error.generic": "Reset failed. Please try again.",
    "reset.back": "Back to decor",
    "reset.back.main": "Back to home",

    // Decor Projects
    "decor.projects.title": "My Projects",
    "decor.projects.subtitle": "Manage your interior design projects",
    "decor.projects.create": "New Project",
    "decor.projects.newProject": "New Project",
    "decor.projects.untitled": "Untitled Project",
    "decor.projects.image": "image",
    "decor.projects.images": "images",
    "decor.projects.empty.title": "Start your first project",
    "decor.projects.empty.subtitle": "Create a project to organize your interior design variations and keep track of your creative process.",
    "decor.projects.tutorial.title": "How it works",
    "decor.projects.tutorial.step1.title": "1. Upload your photo",
    "decor.projects.tutorial.step1.desc": "Start with a photo of the room you want to redesign. The AI will analyze the space.",
    "decor.projects.tutorial.step2.title": "2. Select areas to modify",
    "decor.projects.tutorial.step2.desc": "Use the smart mask editor to select walls, floors, or ceilings. Add reference images for colors, textures, or furniture.",
    "decor.projects.tutorial.step3.title": "3. Generate variations",
    "decor.projects.tutorial.step3.desc": "Our AI generates 4 variations instantly. Compare results, keep your favorites, and iterate.",
    "decor.projects.tutorial.features.title": "What you can do:",
    "decor.projects.tutorial.features.feat1": "Automatic versioning for each generation",
    "decor.projects.tutorial.features.feat2": "Side-by-side comparison tool",
    "decor.projects.tutorial.features.feat3": "Curated libraries (colors, textures, furniture)",
    "decor.projects.tutorial.features.feat4": "HD export for presentations",

    "media.title": "Media",
    "media.kicker": "Library",
    "media.subtitle": "Filter by project, type, and date at a glance.",
    "media.tab.mine": "My media",
    "media.tab.public": "Public media",
    "media.filter.type": "Type",
    "media.filter.project": "Project",
    "media.filter.source": "Source",
    "media.filter.source.all": "All",
    "media.filter.source.montage": "Montage",
    "media.filter.source.standard": "Standard",
    "media.filter.sort": "Sort",
    "media.filter.sort.new": "Newest",
    "media.filter.sort.old": "Oldest",
    "media.state.loading": "Loading media...",
    "media.state.empty": "No media matches these filters.",
    "media.picker.count": "selected",
    "media.picker.use": "Use selection",
    "media.archived.kicker": "Archive",
    "media.archived.title": "Archived media",
    "media.archived.subtitle": "Access media from archived projects.",
    "media.archived.link": "Archived projects",
    "media.archived.back": "Back to media",
    "media.archived.empty": "No archived projects.",
    "media.archived.restore": "Restore project",
    "media.archived.delete": "Delete project",
    "media.archived.restoreConfirm": "Restore this project?",
    "media.archived.deleteConfirm": "Delete this project and its media?",
    "media.tab.uploads": "Uploads",
    "media.uploads.title": "Uploads",
    "media.uploads.subtitle": "Import files to use in the picker.",
    "common.guest": "Guest",
    "sidebar.section.main": "Workspace",
    "sidebar.section.streamlit": "Streamlit",
    "sidebar.link.nano": "Creations",
    "sidebar.link.interior": "Interior editor",
    "sidebar.link.decor": "Decor editor",
    "sidebar.link.video": "Video studio",
    "sidebar.link.montage": "Video montage",
    "sidebar.link.editor": "Video editing",
    "sidebar.link.tripo": "Tripo 3D",
    "sidebar.link.media": "Media library",
    "sidebar.link.gallerie": "Gallerie",
    "sidebar.link.music": "Music Studio",
    "sidebar.link.chat": "Chat",
    "sidebar.link.projects": "Projects",
    "sidebar.link.config": "Config",
    "sidebar.chat.empty": "No messages yet.",
    "sidebar.chat.placeholder": "Type a message...",
    "sidebar.chat.send": "Send",
    "sidebar.chat.sending": "Sending...",
    "sidebar.chat.clear": "Clear chat",
    "sidebar.chat.save_notion": "Save to Notion",
    "sidebar.projects.empty": "No projects yet.",
    "sidebar.projects.active": "Active project",
    "sidebar.projects.name": "Project name",
    "sidebar.projects.desc": "Description",
    "sidebar.projects.create": "Create project",
    "sidebar.projects.archive": "Archive project",
    "sidebar.projects.archiving": "Archiving...",
    "sidebar.projects.archiveConfirm": "Archive this project?",
    "sidebar.config.language": "Language",
    "sidebar.config.notionToken": "Notion token",
    "sidebar.config.notionSearchPlaceholder": "Type at least 2 letters",
    "sidebar.config.notionSearch": "Search",
    "sidebar.config.notionPage": "Default Notion page",
    "sidebar.config.videoMode": "Video studio default",
    "sidebar.config.videoModeBeginner": "Beginner",
    "sidebar.config.videoModeExpert": "Expert",
    "sidebar.config.save": "Save",

    "editor.project.title": "Project V2 - Engine Architecture",
    "editor.track.video": "A-Roll (Primary)",
    "editor.track.overlay": "FX & Overlays",
    "editor.track.audio": "Sound Design",
    "editor.clip.noise": "Noise Generator",
    "editor.clip.plasma": "Plasma Effect",
    "editor.clip.checker": "Checkerboard",
    "editor.overlay.text": "ENGINE V2",
    "editor.header.title": "Contentos Engine",
    "editor.header.subtitle": "WebGL Ready • WebAudio Mix",
    "editor.header.fps": "FPS: 60 (Sim)",
    "editor.header.ram": "RAM: 128MB",
    "editor.header.export": "EXPORT 4K",
    "editor.inspector.title": "Inspector",
    "editor.inspector.clipName": "Clip name",
    "editor.inspector.transform": "Transform X / Y",
    "editor.inspector.procGen": "PROCEDURAL GEN",
    "editor.inspector.procGenDesc": "This clip is generated in real time by the render engine (GPU mock).",
    "editor.inspector.empty": "Select a clip on the timeline to edit it.",
    "editor.timeline.duration": "Duration",

    "nano.kicker": "Studio",
    "nano.title": "Nano Banana",
    "nano.subtitle": "Configure, compose, and generate Gemini images.",
    "nano.generate": "Generate",
    "interior.kicker": "Request",
    "interior.title": "Interior request",
    "interior.subtitle": "Select up to 14 images and send your request.",
    "interior.panel.input": "Source images",
    "interior.panel.result": "Request and preview",
    "interior.image.empty": "Select up to 14 images to get started.",
    "interior.prompt.label": "Request",
    "interior.prompt.placeholder": "Write the prompt to send...",
    "interior.send": "Send",
    "interior.send.loading": "Sending...",
    "interior.send.success": "Request sent.",
    "interior.send.error": "Unable to send request.",
    "interior.send.missingImages": "Add at least one image.",
    "interior.send.missingPrompt": "Add a request.",
    "nano.generating": "Generating...",
    "nano.validate": "Validate",
    "nano.validating": "Validating...",
    "common.loading": "Loading...",
    "nano.mode.label": "Mode",
    "nano.mode.beginner": "Beginner",
    "nano.mode.expert": "Expert",
    "nano.config.title": "Configuration",
    "nano.config.model": "Model",
    "nano.config.format": "Format",
    "nano.config.resolution": "Resolution",
    "nano.config.multiturn": "Multi-turn (use last image)",
    "nano.config.grain": "Grain",
    "nano.config.contrast": "Contrast",
    "nano.prompt.title": "Prompt",
    "nano.prompt.placeholder": "Describe your image here...",
    "nano.prompt.presets": "Presets",
    "nano.prompt.recommended": "Recommended prompt",
    "nano.prompt.recommended_empty": "Run validation to get a recommendation.",
    "nano.expert.narrative.title": "Narrative",
    "nano.expert.narrative.subject": "Subject",
    "nano.expert.narrative.action": "Action",
    "nano.expert.narrative.environment": "Environment",
    "nano.expert.narrative.temporal": "Temporal progression",
    "nano.expert.camera.title": "Camera",
    "nano.expert.camera.shotType": "Shot type",
    "nano.expert.camera.cameraMotion": "Camera motion",
    "nano.expert.camera.lens": "Lens",
    "nano.expert.camera.focus": "Focus",
    "nano.expert.camera.framing": "Framing",
    "nano.expert.style.title": "Style",
    "nano.expert.style.lighting": "Lighting",
    "nano.expert.style.colorPalette": "Color palette",
    "nano.expert.style.mood": "Mood",
    "nano.expert.style.artDirection": "Art direction",
    "nano.expert.constraints.title": "Constraints",
    "nano.expert.constraints.identity": "Identity consistency",
    "nano.expert.constraints.noStyleDrift": "No style drift",
    "nano.expert.constraints.noCharacterMerge": "No character merging",
    "nano.images.title": "Source images",
    "decor.editor.kicker": "Editor",
    "decor.editor.title": "Decor studio",
    "decor.editor.subtitle": "Create a mask, add references, and generate multiple variants in one click.",
    "decor.editor.backProjects": "Back to projects",
    "decor.editor.credits": "Credits",
    "decor.editor.zoomOut": "Zoom out",
    "decor.editor.zoomIn": "Zoom in",
    "decor.editor.fit": "Fit",
    "decor.editor.rotateLeft": "Rotate left",
    "decor.editor.rotateRight": "Rotate right",
    "decor.editor.resetRotation": "Reset rotation",
    "decor.editor.contrast": "Contrast",
    "decor.editor.crop": "Crop",
    "decor.editor.mask": "Mask",
    "decor.editor.maskOpacity": "Mask opacity",
    "decor.editor.saving": "Saving...",
    "decor.editor.validate": "Validate",
    "decor.editor.dropImage": "Drop an image here",
    "decor.editor.dropImageSubtitle": "or click to upload your base photo",
    "decor.editor.uploading": "Uploading...",
    "decor.editor.uploadImage": "Upload an image",
    "decor.editor.resizeFrame": "Resize frame",
    "decor.editor.before": "Before",
    "decor.editor.after": "After",
    "decor.editor.basePhoto": "Base photo",
    "decor.editor.baseSelection": "Base selection",
    "decor.editor.noSelection": "No selection",
    "decor.editor.remove": "Remove",
    "decor.editor.drawing": "Drawing",
    "decor.editor.hideDrawing": "Hide drawing",
    "decor.editor.showDrawing": "Show drawing",
    "decor.editor.active": "Active",
    "decor.editor.draw": "Draw",
    "decor.editor.customColor": "Custom color",
    "decor.editor.brushSize": "Brush size",
    "decor.editor.clear": "Clear",
    "decor.editor.aiMask": "AI mask",
    "decor.editor.walls": "Walls",
    "decor.editor.floor": "Floor",
    "decor.editor.wallsFloor": "Walls + floor",
    "decor.editor.ceiling": "Ceiling",
    "decor.editor.all": "All",
    "decor.editor.generating": "Generating...",
    "decor.editor.generateAiMask": "Generate AI mask",
    "decor.editor.add": "Add",
    "decor.editor.reset": "Reset",
    "decor.editor.invert": "Invert",
    "decor.editor.references": "References",
    "decor.editor.addReference": "Add reference",
    "decor.editor.dropRefImage": "Drop an image here",
    "decor.editor.dropRefImageSubtitle": "A reference will be created from this image",
    "decor.editor.palettes": "Palettes",
    "decor.editor.textures": "Textures",
    "decor.editor.furniture": "Furniture",
    "decor.editor.palette": "palette",
    "decor.editor.edit": "Edit",
    "decor.editor.noReference": "No reference.",
    "decor.editor.parameters": "Parameters",
    "decor.editor.extraNotes": "Additional notes",
    "decor.editor.notesPlaceholder": "Ex: Scandinavian mood, light wood...",
    "decor.editor.variants": "Variants",
    "decor.editor.intensity": "Intensity",
    "decor.editor.generate": "Generate",
    "decor.editor.cost": "Will cost",
    "decor.editor.history": "History",
    "decor.editor.noVersion": "No version.",
    "decor.editor.version": "Version",
    "decor.editor.generatedVariants": "Generated variants",
    "decor.editor.variantsGenerated": "variants generated",
    "decor.editor.regenerate": "Regenerate",
    "decor.editor.ready": "Ready",
    "decor.editor.queued": "Queued",
    "decor.editor.open": "Open",
    "decor.editor.download": "Download",
    "decor.editor.keep": "Keep",
    "decor.editor.compare": "Compare",
    "decor.editor.noResult": "No result",
    "decor.editor.editReference": "Edit reference",
    "decor.editor.name": "Name",
    "decor.editor.namePlaceholder": "Ex: Scandinavian palette",
    "decor.editor.colors": "Colors",
    "decor.editor.color": "Color",
    "decor.editor.tones": "Tones (2 colors)",
    "decor.editor.imageUrlOptional": "Image URL (optional)",
    "decor.editor.tagOptional": "Tag (optional)",
    "decor.editor.tagPlaceholder": "Ex: wood, marble, textile...",
    "decor.editor.descriptionOptional": "Description (optional)",
    "decor.editor.notesPersonal": "Personal notes...",
    "decor.editor.create": "Create",
    "decor.editor.err.noMediaSelected": "No media selected.",
    "decor.editor.err.imageUnavailable": "Image unavailable.",
    "decor.editor.err.noEditToApply": "No edit to apply.",
    "decor.editor.err.mediaTransform": "Media transform error.",
    "decor.editor.err.selectBasePhoto": "Select a base photo.",
    "decor.editor.err.generationFailed": "Generation failed.",
    "decor.editor.err.generation": "Generation error.",
    "decor.editor.err.cannotResolveVersion": "Unable to find version to keep.",
    "decor.editor.err.cannotKeepVersion": "Unable to keep this version.",
    "decor.editor.err.updateFailed": "Update failed.",
    "decor.editor.err.imageNotFound": "Image not found.",
    "decor.editor.err.imageDownload": "Unable to download image.",
    "decor.editor.err.segmentation": "Segmentation error.",
    "decor.editor.err.noMaskForCategory": "No mask found for this category.",
    "decor.editor.err.loadReferences": "Failed to load references.",
    "decor.editor.err.billing": "Billing error.",
    "decor.editor.err.loadMedia": "Failed to load media.",
    "decor.editor.err.unknown": "Unknown error.",
    "decor.editor.err.uploadFailed": "Upload failed.",
    "decor.editor.err.noImageAvailable": "No image available.",
    "decor.editor.err.loadVersions": "Failed to load versions.",
    "decor.editor.warn.refLimit": "Reference limit reached",
    "decor.editor.noProject": "No project",
    "decor.editor.err.nameRequired": "Name is required.",
    "decor.editor.err.createReference": "Reference creation failed.",
    "decor.editor.err.updateReference": "Reference update failed.",
    "decor.editor.err.saveReference": "Reference save failed.",
    "decor.editor.confirm.deleteReference": "Delete",
    "decor.editor.err.deleteReference": "Reference deletion failed.",
    "common.cancel": "Cancel",
    "common.menu": "Menu",
    "video.expert.narrative.title": "Narrative",
    "video.expert.narrative.subject": "Subject",
    "video.expert.narrative.action": "Action",
    "video.expert.narrative.environment": "Environment",
    "video.expert.narrative.temporal": "Temporal progression",
    "video.expert.camera.title": "Camera",
    "video.expert.camera.shotType": "Shot type",
    "video.expert.camera.cameraMotion": "Camera motion",
    "video.expert.camera.lens": "Lens",
    "video.expert.camera.focus": "Focus",
    "video.expert.camera.framing": "Framing",
    "video.expert.style.title": "Style",
    "video.expert.style.lighting": "Lighting",
    "video.expert.style.colorPalette": "Color palette",
    "video.expert.style.mood": "Mood",
    "video.expert.style.artDirection": "Art direction",
    "video.expert.constraints.title": "Constraints",
    "video.expert.constraints.identity": "Identity consistency",
    "video.expert.constraints.noStyleDrift": "No style drift",
    "video.expert.constraints.noCharacterMerge": "No character merging",
    "music.kicker": "Studio",
    "music.title": "Music Studio",
    "music.subtitle": "Generate music with AI-powered Lyria.",
    "music.config_title": "Configuration",
    "music.model": "Model",
    "music.prompt_label": "Music prompt",
    "music.prompt_placeholder": "e.g. Minimal techno, 303 acid bass, hypnotic groove...",
    "music.weight": "Prompt weight",
    "music.extra_prompts": "Extra prompts (one line = text|weight)",
    "music.extra_prompts_help": "Example: Piano|1.5",
    "music.duration": "Duration (seconds)",
    "music.bpm_enable": "Set BPM",
    "music.bpm": "BPM",
    "music.guidance": "Guidance",
    "music.temperature": "Temperature",
    "music.density": "Density",
    "music.brightness": "Brightness",
    "music.scale": "Scale",
    "music.mode": "Mode",
    "music.mute_bass": "Reduce bass",
    "music.mute_drums": "Reduce drums",
    "music.only_bass_drums": "Only bass + drums",
    "music.generate": "🎵 Generate",
    "music.spinner": "Generating music...",
    "music.latest": "Latest render",
    "music.recent_title": "Recent audio",
    "music.open_audio": "Open audio",
    "music.result_empty": "No audio yet.",

    // Video Montage
    "montage.step.storyboard": "Storyboard",
    "montage.step.images": "Images",
    "montage.step.videos": "Videos",
    "montage.step.transitions": "Transitions",
    "montage.step.music": "Music",
    "montage.step.assemble": "Assembly",
    "montage.storyboard.desc": "Describe your video project and let the AI automatically generate the segments.",
    "montage.storyboard.descBrief": "Describe your video project and let the AI generate the segments.",
    "montage.label.projectDesc": "Project description",
    "montage.placeholder.desc": "Describe your video: subject, mood, style...",
    "montage.label.targetDuration": "Target duration (seconds)",
    "montage.label.segmentCount": "Number of segments",
    "montage.btn.generating": "Generating...",
    "montage.btn.generateStoryboard": "Generate Storyboard",
    "montage.hint.createFirst": "Create your montage first before generating the storyboard",
    "montage.label.refMedia": "Reference media",
    "montage.label.segmentsGenerated": "Generated segments",
    "montage.btn.enhanceAllTitle": "Enhance all prompts with AI",
    "montage.btn.enhancing": "Enhancing...",
    "montage.btn.enhanceAll": "Enhance all prompts",
    "montage.label.totalDuration": "Total duration",
    "montage.btn.addSegment": "Add a segment",
    "montage.btn.nextImages": "Next: Image Generation \u2192",
    "montage.images.title": "Image Generation",
    "montage.images.descHigh": "Generate start and end images for each segment. The end image allows smoother interpolation.",
    "montage.images.descLow": "Generate start images for each segment. Switch to High quality to also generate end images (interpolation).",
    "montage.warn.noSegments": "\u26a0\ufe0f No segments available. Go back to the Storyboard step to create segments.",
    "montage.btn.backStoryboard": "\u2190 Back to Storyboard",
    "montage.label.config": "Configuration",
    "montage.label.imageQuality": "Image quality",
    "montage.label.estimatedCost": "Estimated cost",
    "montage.label.credits": "credits",
    "montage.btn.deselectAll": "Deselect all",
    "montage.btn.selectAll": "Select all",
    "montage.btn.generate": "Generate",
    "montage.label.segments": "Segments",
    "montage.label.selected": "selected",
    "montage.status.done": "\u2705 Done",
    "montage.status.generating": "\ud83d\udd04 Generating",
    "montage.status.pending": "\u23f3 Pending",
    "montage.label.start": "Start",
    "montage.label.end": "End",
    "montage.btn.nextVideos": "Next: Video Generation \u2192",
    "montage.videos.title": "Video Generation",
    "montage.videos.desc": "Generate videos for each segment. Choose the quality according to your needs.",
    "montage.warn.imagesFirst": "\u26a0\ufe0f Start images must be generated before creating videos.",
    "montage.btn.backImages": "\u2190 Back to Images",
    "montage.label.videoQuality": "Video quality",
    "montage.btn.nextTransitions": "Next: Transitions \u2192",
    "montage.transitions.title": "Timeline & Transitions",
    "montage.transitions.desc": "Organize your segments and edit transitions between them.",
    "montage.warn.videosFirst": "\u26a0\ufe0f Videos must be generated before managing transitions.",
    "montage.btn.backVideos": "\u2190 Back to Videos",
    "montage.label.preview": "\ud83c\udfa5 Preview",
    "montage.label.timeline": "\ud83d\udcca Timeline",
    "montage.instructions.title": "\ud83d\udca1 Instructions",
    "montage.instructions.click": "\ud83c\udfaf Click on a segment to select it",
    "montage.instructions.drag": "\ud83d\udd00 Drag and drop segments to reorder them",
    "montage.instructions.transitions": "\u2702\ufe0f Click on zones between segments to edit transitions",
    "montage.instructions.playback": "\u25b6\ufe0f Use playback controls to preview",
    "montage.btn.nextMusic": "Next: Music \u2192",
    "montage.music.title": "Music",
    "montage.music.desc": "Music generation and background synchronization.",
    "montage.assemble.title": "Final Assembly",
    "montage.assemble.desc": "Assembly of all elements and export of the final video.",
    "montage.btn.back": "Back",
    "montage.format.undefined": "Format undefined",
    "montage.format.portrait": "Portrait",
    "montage.format.landscape": "Landscape",
    "montage.format.square": "Square",
    "montage.label.format": "Format",
    "montage.saving": "Saving...",
    "montage.err.exportFailed": "Export failed:",
    "montage.kicker": "Video Montage Studio",
    "montage.title": "Video Montage",
    "montage.subtitle": "Create professional AI-assisted videos",
    "montage.list.title": "My Montages",
    "montage.list.new": "New",
    "montage.status.completed": "Completed",
    "montage.status.exporting": "Exporting...",
    "montage.status.error": "Error",
    "montage.status.draft": "Draft",
    "montage.list.open": "Open",
    "montage.list.opened": "Opened",
    "common.delete": "Delete",
    "montage.create.title": "Create a new montage",
    "montage.label.montageTitle": "Montage title",
    "montage.placeholder.title": "My awesome montage...",
    "montage.label.resolution": "Resolution",
    "montage.btn.creating": "Creating...",
    "montage.btn.createMontage": "Create Montage",
    "montage.label.estimatedSegments": "Estimated segments",
    "montage.untitled": "Untitled",
    "montage.confirm.delete": "Delete this montage?",
    "montage.err.create": "Unable to create montage.",
    "montage.err.delete": "Unable to delete montage.",
    "montage.err.descRequired": "Please add a project description.",
    "montage.err.enhance": "Prompt enhancement failed.",
    "montage.err.export": "Unable to start export.",
    "montage.err.genImages": "Image generation failed.",
    "montage.err.genVideos": "Video generation failed.",
    "montage.err.load": "Unable to load montage.",
    "montage.err.noSegment": "No segment available.",
    "montage.err.notCreated": "Create a montage first.",
    "montage.err.preview": "Preview unavailable.",
    "montage.err.regenerate": "Unable to regenerate this segment.",
    "montage.err.save": "Unable to save montage.",
    "montage.err.storyboard": "Storyboard generation failed.",
    "montage.err.titleRequired": "Montage title is required.",
    "montage.toast.autoSave": "Auto-save complete.",
    "montage.toast.created": "Montage created.",
    "montage.toast.enhanced": "Prompts enhanced.",
    "montage.toast.exportStarted": "Export started.",
    "montage.toast.imagesGen": "Images generated.",
    "montage.toast.refAdded": "Reference added.",
    "montage.toast.saved": "Montage saved.",
    "montage.toast.segmentSaved": "Segment saved.",
    "montage.toast.storyboardGenerated": "Storyboard generated",
    "montage.toast.videosGen": "Videos generated.",
    "montage.toolbar.addSegment": "Add segment",
    "montage.toolbar.enhance": "Enhance",
    "montage.toolbar.enhanceAll": "Enhance all prompts",
    "montage.toolbar.export": "Export",
    "montage.toolbar.exportTitle": "Export final video",
    "montage.toolbar.exporting": "Exporting...",
    "montage.toolbar.genImages": "Generate images",
    "montage.toolbar.genImagesFirst": "Generate images first",
    "montage.toolbar.genVideos": "Generate videos",
    "montage.toolbar.images": "Images",
    "montage.toolbar.save": "Save",
    "montage.toolbar.videos": "Videos",
    "preview.awaitingImages": "Awaiting generated images",
    "preview.end": "End",
    "preview.loadError": "Unable to load preview media.",
    "preview.noContent": "No content",
    "preview.noSegment": "No segment selected.",
    "preview.playError": "Unable to start playback.",
    "preview.restart": "Restart",
    "pricing.buy": "Buy",
    "pricing.credits": "credits",
    "pricing.creditsIncluded": "Credits included",
    "pricing.creditsMonth": "credits/month",
    "pricing.creditsRemaining": "Credits remaining",
    "pricing.creditsUsed": "Credits used",
    "pricing.error.billing": "Unable to load billing status.",
    "pricing.error.checkout": "Unable to start checkout.",
    "pricing.error.plans": "Unable to load plans.",
    "pricing.error.portal": "Unable to open billing portal.",
    "pricing.error.topups": "Unable to load top-ups.",
    "pricing.noPlans": "No plans available.",
    "pricing.noTopups": "No top-ups available.",
    "pricing.plan": "Plan",
    "pricing.subscribe": "Subscribe",
    "pricing.subscriptions": "Subscriptions",
    "pricing.title": "Pricing",
    "pricing.topups": "Top-ups",
    "pricing.unsubscribe": "Cancel",
    "pricing.yourPlan": "Your plan",
    "segment.aiGeneration": "AI generation",
    "segment.confirmDelete": "Delete segment",
    "segment.confirmRegenerate": "Regenerate segment",
    "segment.deleteImage": "Delete image",
    "segment.descPlaceholder": "Describe this segment...",
    "segment.description": "Description",
    "segment.endImage": "End image",
    "segment.endImagePlaceholder": "Prompt for end image",
    "segment.endImageShort": "End image",
    "segment.fileTooLarge": "File is too large.",
    "segment.format": "Format:",
    "segment.generateEndImage": "Generate end image",
    "segment.generateStartImage": "Generate start image",
    "segment.invalidFileType": "Invalid file type.",
    "segment.landscape": "landscape",
    "segment.montageIs": "montage is",
    "segment.portrait": "portrait",
    "segment.ratioDiffers": "ratio differs",
    "segment.square": "square",
    "segment.startImage": "Start image",
    "segment.startImagePlaceholder": "Prompt for start image",
    "segment.startImageShort": "Start image",
    "segment.upload": "Upload",
    "segment.uploadError": "Upload failed.",
    "segment.usePrevEnd": "Use previous end image",
    "mediasel.library": "Library",
    "mediasel.loadError": "Unable to load library.",
    "mediasel.noSelection": "No media selected.",
    "mediasel.uploadError": "Upload failed.",
    "mediasel.upload": "Upload",
    "transition.crossfade": "Crossfade between segments",
    "transition.dissolve": "Soft dissolve transition",
    "transition.duration": "Duration (seconds)",
    "transition.fade": "Simple fade transition",
    "transition.fromSegment": "From segment",
    "transition.inDesc": "Configure transition into this segment.",
    "transition.inLabel": "Transition in",
    "transition.none": "No transition",
    "transition.outDesc": "Configure transition out of this segment.",
    "transition.outLabel": "Transition out",
    "transition.slide": "Slide transition",
    "transition.title": "Transitions",
    "transition.toSegment": "To segment",
    "transition.type": "Type",
    "transition.wipe": "Wipe transition",
    "transition.zoom": "Zoom transition",
    "sidebar.config.emailNotif": "Email notifications",
    "sidebar.config.notifications": "Notifications",
    "sidebar.config.pushNotif": "Push notifications",
    "sidebar.config.testNotif": "Test notification",
    "sidebar.config.notifDefault": "Use browser default settings.",
    "sidebar.config.notifDenied": "Notifications are blocked in your browser.",
    "sidebar.config.notifGranted": "Notifications are enabled.",
    "sidebar.config.notifUnsupported": "Notifications are not supported on this device.",
    "sidebar.projects.switch": "Switch project",
    "common.close": "Close",
    "common.save": "Save",

    // TripoStudio EN
    "tripo.title": "Tripo 3D",
    "tripo.subtitle": "Simple text-to-3D generation via Tripo API.",
    "tripo.mode.text": "Text to 3D",
    "tripo.mode.image": "Image to 3D",
    "tripo.mode.multiview": "Multiview to 3D",
    "tripo.label.prompt": "Prompt",
    "tripo.label.negative": "Negative prompt (optional)",
    "tripo.placeholder.prompt": "A lowpoly medieval wooden chair...",
    "tripo.placeholder.negative": "blurry, deformed, messy topology",
    "tripo.button.generate": "Generate",
    "tripo.hint.apiKey": "TRIPO_API_KEY required on server.",
    "tripo.results.title": "Results",
    "tripo.results.empty": "No files yet.",
    "tripo.error.billing": "Billing error.",
    "tripo.error.generation": "Generation failed.",
    "tripo.credits.missing": "{missing} / {needed} credits missing, top up!",

    // VideoMontage Components EN
    "montage.toolbar.fast": "Fast",
    "montage.toolbar.medium": "Medium",
    "montage.toolbar.high": "High",
    "montage.toolbar.harmonize": "Harmonize",
    "montage.toolbar.harmonizing": "Harmonizing...",
    "montage.toolbar.harmonizeTitle": "Harmonize video style with Grok",
    "montage.editor.inspector.title": "Segment",
    "montage.editor.inspector.duration": "{duration}s",
    "montage.editor.inspector.save": "Save",
    "montage.editor.inspector.cancel": "Cancel",
    "montage.editor.inspector.close": "Close",
    "montage.editor.inspector.referenceMedia": "Reference Media",
    "montage.editor.inspector.empty": "Click on a segment in the timeline to inspect it",
    "segment.card.title": "Segment {index}",
    "segment.card.duration": "Duration",
    "segment.card.prompt": "Description",
    "segment.card.promptPlaceholder": "Describe this segment...",
    "segment.card.enhancedPrompt": "Enhanced Prompt",
    "segment.card.enhance": "Enhance",
    "segment.card.regenerate": "Regenerate",
    "segment.card.edit": "Edit",
    "segment.card.delete": "Delete",
    "segment.card.save": "Save",
    "segment.card.cancel": "Cancel",
    "segment.card.usePrevEnd": "Use previous end image",
    "segment.card.generate": "Generate",
    "segment.card.reference": "Reference",
    "segment.status.pending": "Pending",
    "segment.status.generating": "Generating...",
    "segment.status.completed": "Completed",
    "segment.status.error": "Error"
  },
  fr: {
    "landing.brand.tag": "Cree, monte, publie — plus vite.",
    "landing.nav.features": "Fonctions",
    "landing.nav.workflow": "Workflow",
    "landing.nav.faq": "FAQ",
    "landing.hero.title": "Le studio pour produire du contenu a grande vitesse.",
    "landing.hero.lead":
      "Centralise tes assets, genere des scripts, assemble des Reels/Shorts, et exporte en formats prets a publier.",
    "landing.badge.templates": "Templates & presets",
    "landing.badge.subtitles": "Sous-titres & branding",
    "landing.badge.exports": "Exports Reels/Shorts/TikTok",
    "landing.badge.editing": "Montage semi-automatique",
    "landing.workflow.title": "Workflow",
    "landing.workflow.step1": "Importe videos, musique, logos",
    "landing.workflow.step2": "Compose sur une timeline (ou auto-edit)",
    "landing.workflow.step3": "Exporte en 1080x1920, audio normalise",
    "landing.tabs.login": "Connexion",
    "landing.tabs.signup": "Creer un compte",
    "landing.field.name": "Nom",
    "landing.field.email": "Email",
    "landing.field.password": "Mot de passe",
    "landing.placeholder.name": "Ton nom",
    "landing.placeholder.email": "toi@exemple.com",
    "landing.placeholder.password": "••••••••",
    "landing.submit.login": "Se connecter",
    "landing.submit.signup": "Creer mon compte",
    "landing.forgot.link": "Mot de passe oublie ?",
    "landing.forgot.title": "Reinitialiser le mot de passe",
    "landing.forgot.subtitle": "Nous envoyons un lien pour reinitialiser votre mot de passe.",
    "landing.forgot.email": "Email",
    "landing.forgot.submit": "Envoyer le lien",
    "landing.forgot.sent": "Email envoye. Verifiez votre boite mail.",
    "terms.prefix": "En continuant, tu acceptes nos",
    "terms.and": "et notre",
    "terms.cgu": "Conditions Generales",
    "terms.privacy": "Politique de Confidentialite",
    "landing.faq.title": "FAQ",
    "landing.faq.access": "J'accede a quoi apres login ?",
    "landing.faq.access.answer": "Tu es redirige vers l'app sur /nano.",
    "landing.faq.design": "Je peux changer le design ?",
    "landing.faq.design.answer": "Oui, c'est du React/CSS classique, facile a brander.",

    // Decor Landing FR
    "decor.brand.name": "DecorAI Studio",
    "decor.brand.tag": "Transforme tes espaces avec l'IA",
    "decor.hero.title": "Redesigne n'importe quelle piece en quelques secondes avec l'IA",
    "decor.hero.lead": "Telecharge une photo, selectionne ce que tu veux changer, et laisse notre IA generer de superbes variations de decoration interieure. Resultats professionnels, liberte creative.",
    "decor.stat.ai": "IA Gemini",
    "decor.stat.variations": "Variations",
    "decor.stat.versions": "Versions",
    "decor.tabs.login": "Connexion",
    "decor.tabs.signup": "Commencer",
    "decor.field.name": "Nom",
    "decor.field.email": "Email",
    "decor.field.password": "Mot de passe",
    "decor.placeholder.name": "Ton nom",
    "decor.placeholder.email": "toi@exemple.com",
    "decor.placeholder.password": "••••••••",
    "decor.submit.login": "Se connecter",
    "decor.submit.signup": "Commencer a creer",
    "decor.forgot.link": "Mot de passe oublie ?",
    "decor.forgot.title": "Reinitialiser le mot de passe",
    "decor.forgot.subtitle": "Nous envoyons un lien pour reinitialiser votre mot de passe.",
    "decor.forgot.email": "Email",
    "decor.forgot.submit": "Envoyer le lien",
    "decor.forgot.sent": "Email envoye. Verifiez votre boite mail.",
    "decor.auth.emailConfirm": "Compte cree ! Verifie ton email pour activer.",
    "decor.features.title": "Tout ce dont tu as besoin pour redesigner",
    "decor.features.subtitle": "Outils professionnels propulses par l'IA pour designers d'interieur et createurs",
    "decor.feature.editor.title": "Editeur de Masque Intelligent",
    "decor.feature.editor.desc": "Selectionne des zones specifiques a modifier. Compare les resultats cote a cote avec une grille de 4 variations.",
    "decor.feature.libraries.title": "Bibliotheques d'Assets",
    "decor.feature.libraries.desc": "Collections organisees de couleurs, textures (bois, beton, marbre) et meubles.",
    "decor.feature.ai.title": "Generation IA",
    "decor.feature.ai.desc": "Propulse par Gemini 3 Pro Image. Utilise plusieurs images de reference pour des resultats precis.",
    "decor.feature.projects.title": "Gestion de Projets",
    "decor.feature.projects.desc": "Versioning automatique, historique complet et export HD pour tous tes designs.",
    "decor.pricing.title": "Tarifs simples et transparents",
    "decor.pricing.subtitle": "Choisis le plan qui correspond a tes besoins creatifs",
    "decor.pricing.popular": "Populaire",
    "decor.pricing.free": "Gratuit",
    "decor.pricing.starter.title": "Starter",
    "decor.pricing.starter.credits": "10 credits gratuits pour commencer",
    "decor.pricing.starter.feat1": "Toutes les fonctionnalites incluses",
    "decor.pricing.starter.feat2": "Acces aux bibliotheques",
    "decor.pricing.starter.feat3": "Export HD",
    "decor.pricing.pack50.title": "Pack 50",
    "decor.pricing.pack50.credits": "50 credits de generation",
    "decor.pricing.pack50.feat1": "Meilleur rapport qualite-prix",
    "decor.pricing.pack50.feat2": "N'expire jamais",
    "decor.pricing.pack50.feat3": "Support prioritaire",
    "decor.pricing.pack200.title": "Pack 200",
    "decor.pricing.pack200.credits": "200 credits de generation",
    "decor.pricing.pack200.feat1": "Economies maximales",
    "decor.pricing.pack200.feat2": "N'expire jamais",
    "decor.pricing.pack200.feat3": "Support prioritaire",
    "decor.pricing.pro.title": "Pro",
    "decor.pricing.pro.credits": "Credits illimites",
    "decor.pricing.pro.feat1": "Generations illimitees",
    "decor.pricing.pro.feat2": "Fonctionnalites avancees",
    "decor.pricing.pro.feat3": "Support prioritaire",
    "decor.pricing.pro.feat4": "Acces anticipe aux nouvelles fonctionnalites",
    "decor.faq.title": "Questions Frequentes",
    "decor.faq.q1": "Comment fonctionne la generation IA ?",
    "decor.faq.a1": "Telecharge une photo de ta piece, utilise l'editeur de masque pour selectionner les zones a modifier, ajoute des images de reference (couleurs, textures, meubles), et notre IA genere 4 variations instantanement.",
    "decor.faq.q2": "Qu'est-ce que les credits ?",
    "decor.faq.a2": "Chaque generation IA coute 1 credit. Tu obtiens 10 credits gratuits pour commencer, puis achete des packs ou abonne-toi a Pro pour des generations illimitees.",
    "decor.faq.q3": "Puis-je exporter en haute resolution ?",
    "decor.faq.a3": "Oui ! Tous les plans incluent l'export HD. Telecharge tes designs en format JPEG ou PNG, parfait pour les presentations ou propositions clients.",
    "decor.faq.q4": "Les credits expirent-ils ?",
    "decor.faq.a4": "Non, les packs de credits achetes n'expirent jamais. Utilise-les a ton rythme. Seul l'abonnement Pro est mensuel.",
    "decor.footer.rights": "Tous droits reserves",

    // Reset Password
    "reset.title": "Reinitialiser le mot de passe",
    "reset.subtitle": "Choisissez un nouveau mot de passe pour votre compte.",
    "reset.password": "Nouveau mot de passe",
    "reset.password.placeholder": "Votre nouveau mot de passe",
    "reset.password.confirm": "Confirmer le mot de passe",
    "reset.password.confirm.placeholder": "Confirmez le mot de passe",
    "reset.submit": "Mettre a jour",
    "reset.success": "Mot de passe mis a jour. Vous pouvez vous connecter.",
    "reset.error.missing": "Lien invalide. Redemandez un reset.",
    "reset.error.generic": "Erreur lors de la reinitialisation.",
    "reset.back": "Retour decor",
    "reset.back.main": "Retour accueil",

    // Decor Projects FR
    "decor.projects.title": "Mes Projets",
    "decor.projects.subtitle": "Gere tes projets de decoration interieure",
    "decor.projects.create": "Nouveau Projet",
    "decor.projects.newProject": "Nouveau Projet",
    "decor.projects.untitled": "Projet sans titre",
    "decor.projects.image": "image",
    "decor.projects.images": "images",
    "decor.projects.empty.title": "Commence ton premier projet",
    "decor.projects.empty.subtitle": "Cree un projet pour organiser tes variations de decoration interieure et suivre ton processus creatif.",
    "decor.projects.tutorial.title": "Comment ca marche",
    "decor.projects.tutorial.step1.title": "1. Telecharge ta photo",
    "decor.projects.tutorial.step1.desc": "Commence avec une photo de la piece que tu veux redesigner. L'IA analysera l'espace.",
    "decor.projects.tutorial.step2.title": "2. Selectionne les zones a modifier",
    "decor.projects.tutorial.step2.desc": "Utilise l'editeur de masque intelligent pour selectionner murs, sols ou plafonds. Ajoute des images de reference pour couleurs, textures ou meubles.",
    "decor.projects.tutorial.step3.title": "3. Genere des variations",
    "decor.projects.tutorial.step3.desc": "Notre IA genere 4 variations instantanement. Compare les resultats, garde tes favoris et itere.",
    "decor.projects.tutorial.features.title": "Ce que tu peux faire :",
    "decor.projects.tutorial.features.feat1": "Versioning automatique pour chaque generation",
    "decor.projects.tutorial.features.feat2": "Outil de comparaison cote a cote",
    "decor.projects.tutorial.features.feat3": "Bibliotheques organisees (couleurs, textures, meubles)",
    "decor.projects.tutorial.features.feat4": "Export HD pour presentations",

    "media.title": "Medias",
    "media.kicker": "Bibliotheque",
    "media.subtitle": "Filtre par projet, type et date en un clin d'oeil.",
    "media.tab.mine": "Mes medias",
    "media.tab.public": "Medias publiques",
    "media.filter.type": "Type",
    "media.filter.project": "Projet",
    "media.filter.source": "Source",
    "media.filter.source.all": "Tous",
    "media.filter.source.montage": "Montage",
    "media.filter.source.standard": "Standard",
    "media.filter.sort": "Tri",
    "media.filter.sort.new": "Plus recent",
    "media.filter.sort.old": "Plus ancien",
    "media.state.loading": "Chargement des medias...",
    "media.state.empty": "Aucun media ne correspond a ces filtres.",
    "media.picker.count": "selection",
    "media.picker.use": "Utiliser la selection",
    "media.archived.kicker": "Archives",
    "media.archived.title": "Medias archives",
    "media.archived.subtitle": "Accedez aux medias des projets archives.",
    "media.archived.link": "Projets archives",
    "media.archived.back": "Retour aux medias",
    "media.archived.empty": "Aucun projet archive.",
    "media.archived.restore": "Restaurer le projet",
    "media.archived.delete": "Supprimer le projet",
    "media.archived.restoreConfirm": "Restaurer ce projet ?",
    "media.archived.deleteConfirm": "Supprimer ce projet et ses medias ?",
    "media.tab.uploads": "Uploads",
    "media.uploads.title": "Uploads",
    "media.uploads.subtitle": "Importe des fichiers pour les utiliser dans le picker.",
    "common.guest": "Invite",
    "sidebar.section.main": "Espace",
    "sidebar.section.streamlit": "Streamlit",
    "sidebar.link.nano": "Creations (Nano Banana)",
    "sidebar.link.interior": "Interieur",
    "sidebar.link.decor": "Edition",
    "sidebar.link.video": "Studio video",
    "sidebar.link.montage": "Montage vidéo IA",
    "sidebar.link.editor": "Montage video",
    "sidebar.link.tripo": "Tripo 3D",
    "sidebar.link.media": "Mediatheque",
    "sidebar.link.gallerie": "Gallerie",
    "sidebar.link.music": "Studio Musique",
    "sidebar.link.chat": "Chat",
    "sidebar.link.projects": "Projets",
    "sidebar.link.config": "Config",
    "sidebar.chat.empty": "Aucun message pour le moment.",
    "sidebar.chat.placeholder": "Ecris un message...",
    "sidebar.chat.send": "Envoyer",
    "sidebar.chat.sending": "Envoi...",
    "sidebar.chat.clear": "Vider le chat",
    "sidebar.chat.save_notion": "Enregistrer dans Notion",
    "sidebar.projects.empty": "Aucun projet.",
    "sidebar.projects.active": "Projet actif",
    "sidebar.projects.name": "Nom du projet",
    "sidebar.projects.desc": "Description",
    "sidebar.projects.create": "Creer un projet",
    "sidebar.projects.archive": "Archiver le projet",
    "sidebar.projects.archiving": "Archivage...",
    "sidebar.projects.archiveConfirm": "Archiver ce projet ?",
    "sidebar.config.language": "Langue",
    "sidebar.config.notionToken": "Token Notion",
    "sidebar.config.notionSearchPlaceholder": "Tape au moins 2 lettres",
    "sidebar.config.notionSearch": "Rechercher",
    "sidebar.config.notionPage": "Page Notion par defaut",
    "sidebar.config.videoMode": "Mode Studio Video",
    "sidebar.config.videoModeBeginner": "Debutant",
    "sidebar.config.videoModeExpert": "Expert",
    "sidebar.config.save": "Enregistrer",

    "editor.project.title": "Projet V2 - Architecture Engine",
    "editor.track.video": "A-Roll (Principal)",
    "editor.track.overlay": "FX & Overlays",
    "editor.track.audio": "Sound Design",
    "editor.clip.noise": "Noise Generator",
    "editor.clip.plasma": "Plasma Effect",
    "editor.clip.checker": "Checkerboard",
    "editor.overlay.text": "MOTEUR V2",
    "editor.header.title": "Contentos Engine",
    "editor.header.subtitle": "WebGL Ready • WebAudio Mix",
    "editor.header.fps": "FPS: 60 (Sim)",
    "editor.header.ram": "RAM: 128MB",
    "editor.header.export": "EXPORT 4K",
    "editor.inspector.title": "Inspecteur",
    "editor.inspector.clipName": "Nom du Clip",
    "editor.inspector.transform": "Transform X / Y",
    "editor.inspector.procGen": "PROCEDURAL GEN",
    "editor.inspector.procGenDesc": "Ce clip est genere en temps reel par le moteur de rendu (GPU mock).",
    "editor.inspector.empty": "Selectionnez un clip dans la timeline pour l'editer.",
    "editor.timeline.duration": "Duree",

    "nano.kicker": "Studio",
    "nano.title": "Nano Banana",
    "nano.subtitle": "Configure, compose, et genere des images Gemini.",
    "nano.generate": "Generer",
    "interior.kicker": "Demande",
    "interior.title": "Demande d'interieur",
    "interior.subtitle": "Selectionne jusqu'a 14 images et envoie ta demande.",
    "interior.panel.input": "Images source",
    "interior.panel.result": "Demande et apercu",
    "interior.image.empty": "Selectionne jusqu'a 14 images pour commencer.",
    "interior.prompt.label": "Demande",
    "interior.prompt.placeholder": "Ecris le prompt a envoyer...",
    "interior.send": "Envoyer",
    "interior.send.loading": "Envoi...",
    "interior.send.success": "Demande envoyee.",
    "interior.send.error": "Envoi impossible.",
    "interior.send.missingImages": "Ajoute au moins une image.",
    "interior.send.missingPrompt": "Ajoute une demande.",
    "nano.generating": "Generation...",
    "nano.validate": "Valider",
    "nano.validating": "Validation...",
    "common.loading": "Chargement...",
    "nano.mode.label": "Mode",
    "nano.mode.beginner": "Debutant",
    "nano.mode.expert": "Expert",
    "nano.config.title": "Configuration",
    "nano.config.model": "Modele",
    "nano.config.format": "Format",
    "nano.config.resolution": "Resolution",
    "nano.config.multiturn": "Multi-tour (utiliser la derniere image)",
    "nano.config.grain": "Grain",
    "nano.config.contrast": "Contraste",
    "nano.prompt.title": "Prompt",
    "nano.prompt.placeholder": "Decris ton image ici...",
    "nano.prompt.presets": "Presets",
    "nano.prompt.recommended": "Prompt recommande",
    "nano.prompt.recommended_empty": "Lance la validation pour une recommandation.",
    "nano.expert.narrative.title": "Narratif",
    "nano.expert.narrative.subject": "Sujet",
    "nano.expert.narrative.action": "Action",
    "nano.expert.narrative.environment": "Environnement",
    "nano.expert.narrative.temporal": "Progression temporelle",
    "nano.expert.camera.title": "Camera",
    "nano.expert.camera.shotType": "Type de plan",
    "nano.expert.camera.cameraMotion": "Mouvement camera",
    "nano.expert.camera.lens": "Objectif",
    "nano.expert.camera.focus": "Mise au point",
    "nano.expert.camera.framing": "Cadrage",
    "nano.expert.style.title": "Style",
    "nano.expert.style.lighting": "Lumiere",
    "nano.expert.style.colorPalette": "Palette couleur",
    "nano.expert.style.mood": "Ambiance",
    "nano.expert.style.artDirection": "Direction artistique",
    "nano.expert.constraints.title": "Contraintes",
    "nano.expert.constraints.identity": "Coherence d'identite",
    "nano.expert.constraints.noStyleDrift": "Pas de derive de style",
    "nano.expert.constraints.noCharacterMerge": "Pas de fusion de personnages",
    "nano.images.title": "Images source",
    "decor.editor.kicker": "Edition",
    "decor.editor.title": "Studio de decoration",
    "decor.editor.subtitle": "Creez un masque, ajoutez des references et lancez plusieurs variantes en un clic.",
    "decor.editor.backProjects": "Retour projets",
    "decor.editor.credits": "Credits",
    "decor.editor.zoomOut": "Zoom arriere",
    "decor.editor.zoomIn": "Zoom avant",
    "decor.editor.fit": "Ajuster",
    "decor.editor.rotateLeft": "Tourner a gauche",
    "decor.editor.rotateRight": "Tourner a droite",
    "decor.editor.resetRotation": "Reinitialiser la rotation",
    "decor.editor.contrast": "Contraste",
    "decor.editor.crop": "Recadrage",
    "decor.editor.mask": "Masque",
    "decor.editor.maskOpacity": "Opacite masque",
    "decor.editor.saving": "Sauvegarde...",
    "decor.editor.validate": "Valider",
    "decor.editor.dropImage": "Glissez une image ici",
    "decor.editor.dropImageSubtitle": "ou cliquez pour uploader votre photo de base",
    "decor.editor.uploading": "Upload...",
    "decor.editor.uploadImage": "Uploader une image",
    "decor.editor.resizeFrame": "Redimensionner le cadre",
    "decor.editor.before": "Avant",
    "decor.editor.after": "Apres",
    "decor.editor.basePhoto": "Photo de base",
    "decor.editor.baseSelection": "Selection de base",
    "decor.editor.noSelection": "Aucune selection",
    "decor.editor.remove": "Retirer",
    "decor.editor.drawing": "Dessin",
    "decor.editor.hideDrawing": "Masquer le dessin",
    "decor.editor.showDrawing": "Afficher le dessin",
    "decor.editor.active": "Actif",
    "decor.editor.draw": "Dessiner",
    "decor.editor.customColor": "Couleur personnalisee",
    "decor.editor.brushSize": "Taille pinceau",
    "decor.editor.clear": "Effacer",
    "decor.editor.aiMask": "Masque IA",
    "decor.editor.walls": "Murs",
    "decor.editor.floor": "Sol",
    "decor.editor.wallsFloor": "Murs + Sol",
    "decor.editor.ceiling": "Plafond",
    "decor.editor.all": "Tout",
    "decor.editor.generating": "Generation...",
    "decor.editor.generateAiMask": "Generer masque IA",
    "decor.editor.add": "Ajouter",
    "decor.editor.reset": "Reinitialiser",
    "decor.editor.invert": "Inverser",
    "decor.editor.references": "References",
    "decor.editor.addReference": "Ajouter une reference",
    "decor.editor.dropRefImage": "Glissez une image ici",
    "decor.editor.dropRefImageSubtitle": "Une reference sera creee avec l'image deja chargee",
    "decor.editor.palettes": "Palettes",
    "decor.editor.textures": "Textures",
    "decor.editor.furniture": "Meubles",
    "decor.editor.palette": "palette",
    "decor.editor.edit": "Modifier",
    "decor.editor.noReference": "Aucune reference.",
    "decor.editor.parameters": "Parametres",
    "decor.editor.extraNotes": "Precisions supplementaires",
    "decor.editor.notesPlaceholder": "Ex: ambiance scandinave, bois clair...",
    "decor.editor.variants": "Variantes",
    "decor.editor.intensity": "Intensite",
    "decor.editor.generate": "Generer",
    "decor.editor.cost": "Coutera",
    "decor.editor.history": "Historique",
    "decor.editor.noVersion": "Aucune version.",
    "decor.editor.version": "Version",
    "decor.editor.generatedVariants": "Variantes generees",
    "decor.editor.variantsGenerated": "variantes generees",
    "decor.editor.regenerate": "Regenerer",
    "decor.editor.ready": "Pret",
    "decor.editor.queued": "En attente",
    "decor.editor.open": "Ouvrir",
    "decor.editor.download": "Telecharger",
    "decor.editor.keep": "Garder",
    "decor.editor.compare": "Comparer",
    "decor.editor.noResult": "Aucun resultat",
    "decor.editor.editReference": "Modifier la reference",
    "decor.editor.name": "Nom",
    "decor.editor.namePlaceholder": "Ex: Palette Scandinave",
    "decor.editor.colors": "Couleurs",
    "decor.editor.color": "Couleur",
    "decor.editor.tones": "Tons (2 couleurs)",
    "decor.editor.imageUrlOptional": "URL Image (optionnel)",
    "decor.editor.tagOptional": "Tag (optionnel)",
    "decor.editor.tagPlaceholder": "Ex: bois, marbre, textile...",
    "decor.editor.descriptionOptional": "Description (optionnel)",
    "decor.editor.notesPersonal": "Notes personnelles...",
    "decor.editor.create": "Creer",
    "decor.editor.err.noMediaSelected": "Aucun media selectionne.",
    "decor.editor.err.imageUnavailable": "Image indisponible.",
    "decor.editor.err.noEditToApply": "Aucune modification a appliquer.",
    "decor.editor.err.mediaTransform": "Erreur transformation media.",
    "decor.editor.err.selectBasePhoto": "Selectionnez une photo de base.",
    "decor.editor.err.generationFailed": "Generation echouee.",
    "decor.editor.err.generation": "Erreur generation.",
    "decor.editor.err.cannotResolveVersion": "Impossible de retrouver la version a garder.",
    "decor.editor.err.cannotKeepVersion": "Impossible de garder cette version.",
    "decor.editor.err.updateFailed": "Erreur lors de la mise a jour.",
    "decor.editor.err.imageNotFound": "Image introuvable.",
    "decor.editor.err.imageDownload": "Impossible de telecharger l'image.",
    "decor.editor.err.segmentation": "Erreur segmentation.",
    "decor.editor.err.noMaskForCategory": "Aucun masque trouve pour cette categorie.",
    "decor.editor.err.loadReferences": "Erreur chargement references.",
    "decor.editor.err.billing": "Erreur billing.",
    "decor.editor.err.loadMedia": "Erreur lors du chargement des medias.",
    "decor.editor.err.unknown": "Erreur inconnue.",
    "decor.editor.err.uploadFailed": "Upload echoue.",
    "decor.editor.err.noImageAvailable": "Aucune image disponible.",
    "decor.editor.err.loadVersions": "Erreur chargement versions.",
    "decor.editor.warn.refLimit": "Limite atteinte",
    "decor.editor.noProject": "Sans projet",
    "decor.editor.err.nameRequired": "Le nom est requis.",
    "decor.editor.err.createReference": "Erreur creation",
    "decor.editor.err.updateReference": "Erreur modification",
    "decor.editor.err.saveReference": "Erreur sauvegarde reference",
    "decor.editor.confirm.deleteReference": "Supprimer",
    "decor.editor.err.deleteReference": "Erreur suppression",
    "common.cancel": "Annuler",
    "common.menu": "Menu",
    "video.expert.narrative.title": "Narratif",
    "video.expert.narrative.subject": "Sujet",
    "video.expert.narrative.action": "Action",
    "video.expert.narrative.environment": "Environnement",
    "video.expert.narrative.temporal": "Progression temporelle",
    "video.expert.camera.title": "Camera",
    "video.expert.camera.shotType": "Type de plan",
    "video.expert.camera.cameraMotion": "Mouvement camera",
    "video.expert.camera.lens": "Objectif",
    "video.expert.camera.focus": "Mise au point",
    "video.expert.camera.framing": "Cadrage",
    "video.expert.style.title": "Style",
    "video.expert.style.lighting": "Lumiere",
    "video.expert.style.colorPalette": "Palette couleur",
    "video.expert.style.mood": "Ambiance",
    "video.expert.style.artDirection": "Direction artistique",
    "video.expert.constraints.title": "Contraintes",
    "video.expert.constraints.identity": "Coherence d'identite",
    "video.expert.constraints.noStyleDrift": "Pas de derive de style",
    "video.expert.constraints.noCharacterMerge": "Pas de fusion de personnages",
    "music.kicker": "Studio",
    "music.title": "Studio Musique",
    "music.subtitle": "Genere de la musique avec l'IA Lyria.",
    "music.config_title": "Configuration",
    "music.model": "Modele",
    "music.prompt_label": "Prompt musical",
    "music.prompt_placeholder": "Ex: Minimal techno, 303 acid bass, groove hypnotique...",
    "music.weight": "Poids du prompt",
    "music.extra_prompts": "Prompts additionnels (une ligne = texte|poids)",
    "music.extra_prompts_help": "Ex: Piano|1.5",
    "music.duration": "Duree (secondes)",
    "music.bpm_enable": "Definir un BPM",
    "music.bpm": "BPM",
    "music.guidance": "Guidance",
    "music.temperature": "Temperature",
    "music.density": "Densite",
    "music.brightness": "Brillance",
    "music.scale": "Gamme",
    "music.mode": "Mode",
    "music.mute_bass": "Reduire les basses",
    "music.mute_drums": "Reduire les drums",
    "music.only_bass_drums": "Uniquement basses + drums",
    "music.generate": "🎵 Generer",
    "music.spinner": "Generation musicale...",
    "music.latest": "Dernier rendu",
    "music.recent_title": "Audios recents",
    "music.open_audio": "Ouvrir l'audio",
    "music.result_empty": "Aucun audio pour le moment.",

    // Video Montage
    "montage.step.storyboard": "Storyboard",
    "montage.step.images": "Images",
    "montage.step.videos": "Videos",
    "montage.step.transitions": "Transitions",
    "montage.step.music": "Musique",
    "montage.step.assemble": "Assemblage",
    "montage.storyboard.desc": "Decrivez votre projet video et laissez l'IA generer automatiquement les segments.",
    "montage.storyboard.descBrief": "Decrivez votre projet video et laissez l'IA generer les segments.",
    "montage.label.projectDesc": "Description du projet",
    "montage.placeholder.desc": "Decrivez votre video : sujet, ambiance, style...",
    "montage.label.targetDuration": "Duree cible (secondes)",
    "montage.label.segmentCount": "Nombre de segments",
    "montage.btn.generating": "Generation en cours...",
    "montage.btn.generateStoryboard": "Generer le Storyboard",
    "montage.hint.createFirst": "Creez d'abord votre montage avant de generer le storyboard",
    "montage.label.refMedia": "Medias de reference",
    "montage.label.segmentsGenerated": "Segments generes",
    "montage.btn.enhanceAllTitle": "Ameliorer tous les prompts avec l'IA",
    "montage.btn.enhancing": "Amelioration...",
    "montage.btn.enhanceAll": "Ameliorer tous les prompts",
    "montage.label.totalDuration": "Duree totale",
    "montage.btn.addSegment": "Ajouter un segment",
    "montage.btn.nextImages": "Suivant : Generation d'Images \u2192",
    "montage.images.title": "Generation d'Images",
    "montage.images.descHigh": "Generez les images de debut et fin pour chaque segment. L'image de fin permet une interpolation plus fluide.",
    "montage.images.descLow": "Generez les images de debut pour chaque segment. Passez en qualite High pour generer aussi les images de fin (interpolation).",
    "montage.warn.noSegments": "\u26a0\ufe0f Aucun segment disponible. Retournez a l'etape Storyboard pour creer des segments.",
    "montage.btn.backStoryboard": "\u2190 Retour au Storyboard",
    "montage.label.config": "Configuration",
    "montage.label.imageQuality": "Qualite des images",
    "montage.label.estimatedCost": "Cout estime",
    "montage.label.credits": "credits",
    "montage.btn.deselectAll": "Tout deselectionner",
    "montage.btn.selectAll": "Tout selectionner",
    "montage.btn.generate": "Generer",
    "montage.label.segments": "Segments",
    "montage.label.selected": "selectionne(s)",
    "montage.status.done": "\u2705 Termine",
    "montage.status.generating": "\ud83d\udd04 En cours",
    "montage.status.pending": "\u23f3 En attente",
    "montage.label.start": "Debut",
    "montage.label.end": "Fin",
    "montage.btn.nextVideos": "Suivant : Generation de Videos \u2192",
    "montage.videos.title": "Generation de Videos",
    "montage.videos.desc": "Generez les videos pour chaque segment. Choisissez la qualite selon vos besoins.",
    "montage.warn.imagesFirst": "\u26a0\ufe0f Les images de debut doivent etre generees avant de creer les videos.",
    "montage.btn.backImages": "\u2190 Retour aux Images",
    "montage.label.videoQuality": "Qualite des videos",
    "montage.btn.nextTransitions": "Suivant : Transitions \u2192",
    "montage.transitions.title": "Timeline & Transitions",
    "montage.transitions.desc": "Organisez vos segments et editez les transitions entre eux.",
    "montage.warn.videosFirst": "\u26a0\ufe0f Les videos doivent etre generees avant de gerer les transitions.",
    "montage.btn.backVideos": "\u2190 Retour aux Videos",
    "montage.label.preview": "\ud83c\udfa5 Apercu",
    "montage.label.timeline": "\ud83d\udcca Timeline",
    "montage.instructions.title": "\ud83d\udca1 Instructions",
    "montage.instructions.click": "\ud83c\udfaf Cliquez sur un segment pour le selectionner",
    "montage.instructions.drag": "\ud83d\udd00 Glissez-deposez les segments pour les reorganiser",
    "montage.instructions.transitions": "\u2702\ufe0f Cliquez sur les zones entre segments pour editer les transitions",
    "montage.instructions.playback": "\u25b6\ufe0f Utilisez les controles de lecture pour previsualiser",
    "montage.btn.nextMusic": "Suivant : Musique \u2192",
    "montage.music.title": "Musique",
    "montage.music.desc": "Generation et synchronisation de la musique de fond.",
    "montage.assemble.title": "Assemblage Final",
    "montage.assemble.desc": "Assemblage de tous les elements et export de la video finale.",
    "montage.btn.back": "Retour",
    "montage.format.undefined": "Format non defini",
    "montage.format.portrait": "Portrait",
    "montage.format.landscape": "Paysage",
    "montage.format.square": "Carre",
    "montage.label.format": "Format",
    "montage.saving": "Sauvegarde...",
    "montage.err.exportFailed": "Export echoue :",
    "montage.kicker": "Studio Montage Video",
    "montage.title": "Montage Video",
    "montage.subtitle": "Creez des videos professionnelles assistees par IA",
    "montage.list.title": "Mes Montages",
    "montage.list.new": "Nouveau",
    "montage.status.completed": "Termine",
    "montage.status.exporting": "Export...",
    "montage.status.error": "Erreur",
    "montage.status.draft": "Brouillon",
    "montage.list.open": "Ouvrir",
    "montage.list.opened": "Ouvert",
    "common.delete": "Supprimer",
    "montage.create.title": "Creer un nouveau montage",
    "montage.label.montageTitle": "Titre du montage",
    "montage.placeholder.title": "Mon super montage...",
    "montage.label.resolution": "Resolution",
    "montage.btn.creating": "Creation...",
    "montage.btn.createMontage": "Creer le Montage",
    "montage.label.estimatedSegments": "Segments estimes",
    "montage.untitled": "Sans titre",
    "montage.confirm.delete": "Supprimer ce montage ?",
    "montage.err.create": "Creation du montage impossible.",
    "montage.err.delete": "Suppression du montage impossible.",
    "montage.err.descRequired": "Ajoutez une description du projet.",
    "montage.err.enhance": "Echec de l'amelioration du prompt.",
    "montage.err.export": "Impossible de lancer l'export.",
    "montage.err.genImages": "Echec de generation des images.",
    "montage.err.genVideos": "Echec de generation des videos.",
    "montage.err.load": "Chargement du montage impossible.",
    "montage.err.noSegment": "Aucun segment disponible.",
    "montage.err.notCreated": "Creez d'abord un montage.",
    "montage.err.preview": "Apercu indisponible.",
    "montage.err.regenerate": "Impossible de regenerer ce segment.",
    "montage.err.save": "Sauvegarde du montage impossible.",
    "montage.err.storyboard": "Echec de generation du storyboard.",
    "montage.err.titleRequired": "Le titre du montage est requis.",
    "montage.toast.autoSave": "Auto-sauvegarde terminee.",
    "montage.toast.created": "Montage cree.",
    "montage.toast.enhanced": "Prompts ameliores.",
    "montage.toast.exportStarted": "Export demarre.",
    "montage.toast.imagesGen": "Images generees.",
    "montage.toast.refAdded": "Reference ajoutee.",
    "montage.toast.saved": "Montage sauvegarde.",
    "montage.toast.segmentSaved": "Segment sauvegarde.",
    "montage.toast.storyboardGenerated": "Storyboard genere",
    "montage.toast.videosGen": "Videos generees.",
    "montage.toolbar.addSegment": "Ajouter segment",
    "montage.toolbar.enhance": "Ameliorer",
    "montage.toolbar.enhanceAll": "Ameliorer tous les prompts",
    "montage.toolbar.export": "Exporter",
    "montage.toolbar.exportTitle": "Exporter la video finale",
    "montage.toolbar.exporting": "Export...",
    "montage.toolbar.genImages": "Generer les images",
    "montage.toolbar.genImagesFirst": "Generez d'abord les images",
    "montage.toolbar.genVideos": "Generer les videos",
    "montage.toolbar.images": "Images",
    "montage.toolbar.save": "Sauvegarder",
    "montage.toolbar.videos": "Videos",
    "preview.awaitingImages": "En attente des images generees",
    "preview.end": "Fin",
    "preview.loadError": "Impossible de charger le media d'apercu.",
    "preview.noContent": "Aucun contenu",
    "preview.noSegment": "Aucun segment selectionne.",
    "preview.playError": "Impossible de lancer la lecture.",
    "preview.restart": "Recommencer",
    "pricing.buy": "Acheter",
    "pricing.credits": "credits",
    "pricing.creditsIncluded": "Credits inclus",
    "pricing.creditsMonth": "credits/mois",
    "pricing.creditsRemaining": "Credits restants",
    "pricing.creditsUsed": "Credits utilises",
    "pricing.error.billing": "Impossible de charger votre statut de facturation.",
    "pricing.error.checkout": "Impossible de lancer le paiement.",
    "pricing.error.plans": "Impossible de charger les offres.",
    "pricing.error.portal": "Impossible d'ouvrir le portail de facturation.",
    "pricing.error.topups": "Impossible de charger les top-ups.",
    "pricing.noPlans": "Aucune offre disponible.",
    "pricing.noTopups": "Aucun top-up disponible.",
    "pricing.plan": "Offre",
    "pricing.subscribe": "Souscrire",
    "pricing.subscriptions": "Abonnements",
    "pricing.title": "Tarifs",
    "pricing.topups": "Top-ups",
    "pricing.unsubscribe": "Resilier",
    "pricing.yourPlan": "Votre offre",
    "segment.aiGeneration": "Generation IA",
    "segment.confirmDelete": "Supprimer le segment",
    "segment.confirmRegenerate": "Regenerer le segment",
    "segment.deleteImage": "Supprimer l'image",
    "segment.descPlaceholder": "Decrivez ce segment...",
    "segment.description": "Description",
    "segment.endImage": "Image de fin",
    "segment.endImagePlaceholder": "Prompt de l'image de fin",
    "segment.endImageShort": "Image fin",
    "segment.fileTooLarge": "Fichier trop volumineux.",
    "segment.format": "Format :",
    "segment.generateEndImage": "Generer l'image de fin",
    "segment.generateStartImage": "Generer l'image de debut",
    "segment.invalidFileType": "Type de fichier invalide.",
    "segment.landscape": "paysage",
    "segment.montageIs": "le montage est",
    "segment.portrait": "portrait",
    "segment.ratioDiffers": "le ratio differe",
    "segment.square": "carre",
    "segment.startImage": "Image de debut",
    "segment.startImagePlaceholder": "Prompt de l'image de debut",
    "segment.startImageShort": "Image debut",
    "segment.upload": "Uploader",
    "segment.uploadError": "Echec de l'upload.",
    "segment.usePrevEnd": "Utiliser l'image de fin precedente",
    "mediasel.library": "Bibliotheque",
    "mediasel.loadError": "Impossible de charger la bibliotheque.",
    "mediasel.noSelection": "Aucun media selectionne.",
    "mediasel.uploadError": "Echec de l'upload.",
    "mediasel.upload": "Importer",
    "transition.crossfade": "Fondu croise entre segments",
    "transition.dissolve": "Transition dissolve douce",
    "transition.duration": "Duree (secondes)",
    "transition.fade": "Transition par fondu simple",
    "transition.fromSegment": "Depuis le segment",
    "transition.inDesc": "Configurer la transition vers ce segment.",
    "transition.inLabel": "Transition d'entree",
    "transition.none": "Aucune transition",
    "transition.outDesc": "Configurer la transition depuis ce segment.",
    "transition.outLabel": "Transition de sortie",
    "transition.slide": "Transition glissee",
    "transition.title": "Transitions",
    "transition.toSegment": "Vers le segment",
    "transition.type": "Type",
    "transition.wipe": "Transition balayage",
    "transition.zoom": "Transition zoom",
    "sidebar.config.emailNotif": "Notifications email",
    "sidebar.config.notifications": "Notifications",
    "sidebar.config.pushNotif": "Notifications push",
    "sidebar.config.testNotif": "Tester la notification",
    "sidebar.config.notifDefault": "Utiliser les reglages navigateur par defaut.",
    "sidebar.config.notifDenied": "Les notifications sont bloquees dans le navigateur.",
    "sidebar.config.notifGranted": "Les notifications sont activees.",
    "sidebar.config.notifUnsupported": "Les notifications ne sont pas supportees sur cet appareil.",
    "sidebar.projects.switch": "Basculer de projet",
    "common.close": "Fermer",
    "common.save": "Enregistrer",

    "pricing.title": "Tarifs",
    "pricing.yourPlan": "Votre offre",
    "pricing.plan": "Offre",
    "pricing.creditsUsed": "Credits utilises",
    "pricing.creditsRemaining": "Credits restants",
    "pricing.creditsIncluded": "Credits inclus",
    "pricing.subscriptions": "Abonnements",
    "pricing.creditsMonth": "credits/mois",
    "pricing.subscribe": "Souscrire",
    "pricing.unsubscribe": "Resilier",
    "pricing.noPlans": "Aucune offre disponible.",
    "pricing.topups": "Top-ups",
    "pricing.buy": "Acheter",
    "pricing.credits": "credits",
    "pricing.noTopups": "Aucun top-up disponible.",
    "pricing.error.billing": "Impossible de charger votre statut de facturation.",
    "pricing.error.plans": "Impossible de charger les offres.",
    "pricing.error.topups": "Impossible de charger les top-ups.",
    "pricing.error.checkout": "Impossible de lancer le paiement.",
    "pricing.error.portal": "Impossible d'ouvrir le portail de facturation.",

    // TripoStudio FR
    "tripo.title": "Tripo 3D",
    "tripo.subtitle": "Génération simple text-to-3D via API Tripo.",
    "tripo.mode.text": "Texte vers 3D",
    "tripo.mode.image": "Image vers 3D",
    "tripo.mode.multiview": "Multiview vers 3D",
    "tripo.label.prompt": "Prompt",
    "tripo.label.negative": "Prompt négatif (optionnel)",
    "tripo.placeholder.prompt": "Une chaise médiévale en bois lowpoly...",
    "tripo.placeholder.negative": "flou, déformé, maillage désordonné",
    "tripo.button.generate": "Générer",
    "tripo.hint.apiKey": "TRIPO_API_KEY requis côté serveur.",
    "tripo.results.title": "Résultats",
    "tripo.results.empty": "Aucun fichier pour le moment.",
    "tripo.error.billing": "Erreur de facturation.",
    "tripo.error.generation": "Génération échouée.",
    "tripo.credits.missing": "{missing} / {needed} crédits manquants, rechargez !",

    // VideoMontage Components FR
    "montage.toolbar.fast": "Rapide",
    "montage.toolbar.medium": "Moyen",
    "montage.toolbar.high": "Élevé",
    "montage.toolbar.harmonize": "Harmoniser",
    "montage.toolbar.harmonizing": "Harmonisation...",
    "montage.toolbar.harmonizeTitle": "Harmoniser le style des vidéos avec Grok",
    "montage.editor.inspector.title": "Segment",
    "montage.editor.inspector.duration": "{duration}s",
    "montage.editor.inspector.save": "Enregistrer",
    "montage.editor.inspector.cancel": "Annuler",
    "montage.editor.inspector.close": "Fermer",
    "montage.editor.inspector.referenceMedia": "Médias de référence",
    "montage.editor.inspector.empty": "Cliquez sur un segment dans la timeline pour l'inspecter",
    "segment.card.title": "Segment {index}",
    "segment.card.duration": "Durée",
    "segment.card.prompt": "Description",
    "segment.card.promptPlaceholder": "Décrivez ce segment...",
    "segment.card.enhancedPrompt": "Prompt amélioré",
    "segment.card.enhance": "Améliorer",
    "segment.card.regenerate": "Régénérer",
    "segment.card.edit": "Éditer",
    "segment.card.delete": "Supprimer",
    "segment.card.save": "Sauvegarder",
    "segment.card.cancel": "Annuler",
    "segment.card.usePrevEnd": "Utiliser l'image de fin précédente",
    "segment.card.generate": "Générer",
    "segment.card.reference": "Référence",
    "segment.status.pending": "En attente",
    "segment.status.generating": "Génération...",
    "segment.status.completed": "Terminé",
    "segment.status.error": "Erreur"
  }
};

export function getLocale() {
  if (typeof window === "undefined") return DEFAULT_LOCALE;
  const params = new URLSearchParams(window.location.search);
  const paramLang = params.get("lang");
  if (paramLang && TRANSLATIONS[paramLang]) {
    try {
      window.localStorage.setItem("contentos_lang", paramLang);
    } catch {
      // ignore
    }
    return paramLang;
  }
  try {
    const stored = window.localStorage.getItem("contentos_lang");
    if (stored && TRANSLATIONS[stored]) return stored;
  } catch {
    // ignore
  }
  return DEFAULT_LOCALE;
}

export function t(key, fallback = "") {
  const locale = getLocale();
  return TRANSLATIONS[locale]?.[key] || fallback || TRANSLATIONS[DEFAULT_LOCALE]?.[key] || key;
}
